import { AUTH_ENDPOINT } from "Constants";
import { baseApi as api } from "Services";
import {
  GetSessionConfigRequest,
  GetSessionConfigResponse,
  UpdateSessionConfigRequest,
} from "../types";

export const sessionApi = api.injectEndpoints({
  endpoints: (build) => ({
    updateSessionConfig: build.mutation<
      GetSessionConfigResponse,
      UpdateSessionConfigRequest
    >({
      query: (queryArg) => ({
        url: `${AUTH_ENDPOINT}/session-configuration`,
        method: "PATCH",
        params: {
          org_id: queryArg.organizationId,
        },
        body: queryArg.body,
      }),
    }),
    getSessionConfig: build.query<
      GetSessionConfigResponse,
      GetSessionConfigRequest
    >({
      query: (queryArg) => ({
        url: `${AUTH_ENDPOINT}/session-configuration`,
        params: {
          org_id: queryArg.organizationId,
        },
      }),
    }),
  }),
});

export const { useUpdateSessionConfigMutation, useGetSessionConfigQuery } =
  sessionApi;
